import { render, staticRenderFns } from "./moreButton.vue?vue&type=template&id=db70b19a&scoped=true&"
import script from "./moreButton.vue?vue&type=script&lang=js&"
export * from "./moreButton.vue?vue&type=script&lang=js&"
import style0 from "./moreButton.vue?vue&type=style&index=0&id=db70b19a&prod&lang=css&"
import style1 from "./moreButton.vue?vue&type=style&index=1&id=db70b19a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db70b19a",
  null
  
)

export default component.exports